// Where a child on the ground is near enough to the stairs' base for UP to mount them (StairsController):
// 80 px left of the base to 30 px right of it, 130 px above to 70 px below, in feet coordinates.
export function nearStairBase(feet, [bx, by]) {
  return feet.x > bx - 80 && feet.x < bx + 30 && feet.y > by - 130 && feet.y < by + 70;
}
